import { VideoMetadata } from "@nova/slice-video"
import { selectVideoFlightById } from "features/entity-caching/flights/selectors"
import { GenericFlightPathAssetsThumbnail } from "../generics/genericAssetsListThumbnails"
import { useEffect, useState } from "react"
import {
    useHasFetchedOriginalData,
    useVideoData,
} from "plugins/Video/controllers/hooks/useControllerEvents"

export function VideoAssetsThumbnail({ id }: { id: string }) {
    const [metadata, isLoading] = useVideoMetadata({ flightId: id })
    return (
        <GenericFlightPathAssetsThumbnail
            id={id}
            selectEntity={selectVideoFlightById}
            getMetadata={async () => metadata}
            isLoading={isLoading}
        />
    )
}

function useVideoMetadata({ flightId }: { flightId: string }) {
    const [metadata, setMetadata] = useState<VideoMetadata>([])
    const data = useVideoData({ flightId, options: { fetchDataImmediately: true } })
    const hasFetchedOriginalData = useHasFetchedOriginalData({ flightId })
    useEffect(() => {
        const filtered = data.filter(
            (e, i) => e.timestamp !== data?.[i - 1]?.timestamp && !!e.latitude && !!e.longitude
        )
        setMetadata(filtered.map((data) => [data.longitude, data.latitude, 0, 0, 0, 0, 0, 0]) || [])
    }, [data])
    return [metadata, !hasFetchedOriginalData] as const
}
